var mockData = {
  variation: 'Variation-A',
  keyCategories: [{
    sys: {
      id: '4e2b1fc3-bdb1-509c-8ee0-cba3cbdf0092'
    },
    label: 'About Us',
    url: 'http://www.nva.com/about-us',
    dataAnalyticsValue: 'about-us'
  }, {
    sys: {
      id: 'c909e21b-d4ce-5bdc-8a92-b1bfba896972'
    },
    keyCategoryName: 'Services',
    name: 'Services Category',
    dataAnalyticsValue: 'services-category',
    groupCollection: {
      items: [{
        sys: {
          id: '849ba7a9-5a11-55b7-ae1b-b4909a25304f'
        },
        name: 'Services Group Container 1',
        groupItemCollection: {
          items: [{
            sys: {
              id: 'b9a06fd7-7680-509b-b85e-d44cab905726'
            },
            itemName: 'Main Services'
          }, {
            sys: {
              id: '28191bfd-aba6-5999-8c83-b1af7e5c5303'
            },
            label: 'Vaccination',
            url: 'http://www.nva.com/vaccination'
          }, {
            sys: {
              id: '24066652-7ad2-580a-ab58-b4f7543ad8b6'
            },
            label: 'Annual Checkups',
            url: 'http://www.nva.com/annual-checkup'
          }, {
            sys: {
              id: '3578332e-4037-5c1f-8da3-149b673a8601'
            },
            itemName: 'Wellness Plans'
          }, {
            sys: {
              id: '013a5210-b84a-541c-9166-30094e1025f1'
            },
            label: 'Grooming',
            url: 'http://www.nva.com'
          }, {
            sys: {
              id: 'c2777ed4-9595-5217-b5ba-23f8024ac98e'
            },
            label: 'Dentistry',
            url: 'https://www.nva.com/'
          }]
        }
      }, {
        sys: {
          id: '390b16dd-d485-5131-8415-da03e0fd37b2'
        },
        name: 'Services Group Container 2',
        groupItemCollection: {
          items: [{
            sys: {
              id: '99875f3b-f6c2-5165-b0fc-9e9ff493c42e'
            },
            itemName: 'Life Stages'
          }, {
            sys: {
              id: '744be322-becb-5dbe-94dd-23855de71744'
            },
            label: 'New Pet Care',
            url: 'http://www.nva.com'
          }, {
            sys: {
              id: 'd9df75a0-8bf8-5dfc-b188-878d81b5ef34'
            },
            label: 'Adult Care',
            url: 'http://www.nva.com'
          }]
        }
      }, {
        sys: {
          id: '208f929a-2970-52e9-b076-8564d4885dc4'
        },
        name: 'Services Group Container 3',
        groupItemCollection: {
          items: [{
            sys: {
              id: '713194fb-92a8-56d2-84cb-434df5496d0f'
            },
            itemName: 'Special Treated'
          }, {
            sys: {
              id: '6d27c1f8-3f7d-59a4-94c7-53d6f95442cd'
            },
            label: 'Surgery',
            url: 'http://www.nva.com'
          }, {
            sys: {
              id: 'e545808e-7598-5d3a-b19f-058e1d567f5d'
            },
            label: 'Accupucture',
            url: 'http://www.nva.com'
          }]
        }
      }, {
        sys: {
          id: '692c449b-02f2-5d7d-a35f-3f0948467a16'
        },
        name: 'Services Group Container 4',
        groupItemCollection: {
          items: [{
            sys: {
              id: '1c5fcbf2-5c1b-588e-8755-824de3da48aa'
            },
            itemName: 'Species Treated'
          }, {
            sys: {
              id: '8a0c0399-8960-554b-bd46-8cf1d935df5c'
            },
            itemName: 'Others'
          }, {
            sys: {
              id: '2d1b39f9-44ba-5974-8e9f-72161045de43'
            },
            label: 'Careers',
            url: 'http://www.nva.com/careers'
          }]
        }
      }]
    }
  }, {
    sys: {
      id: '85400c8b-0fcb-5fdf-bd28-9a40e2d77849'
    },
    label: 'Events',
    url: 'http://www.nva.com/testimonials',
    dataAnalyticsValue: 'events'
  }, {
    sys: {
      id: 'd9f9e1d6-7afb-54fb-8574-4a6394ee62d5'
    },
    label: 'Promotions',
    url: 'https://www.nva.com/promotions',
    dataAnalyticsValue: 'promotions'
  }, {
    sys: {
      id: 'eed6be15-7f82-5a01-84c9-50ee0977c0e5'
    },
    keyCategoryName: 'Resources',
    name: 'Resources Category ',
    dataAnalyticsValue: 'resources',
    groupCollection: {
      items: [{
        sys: {
          id: '47a33d50-ad21-5d6b-8b93-e5fa08a13be0'
        },
        name: 'Resources Group Container 1',
        groupItemCollection: {
          items: [{
            sys: {
              id: '4e988760-2a88-5599-9c07-0fbfcb50ed63'
            },
            label: 'Terms & Conditions',
            url: 'http://www.nva.com/privacy-policy'
          }, {
            sys: {
              id: '9151eba6-a99f-5643-bc0e-b8fe86e7daf5'
            },
            label: 'Privacy Policy',
            url: null
          }, {
            sys: {
              id: 'a0270494-502f-51a5-abd7-bef8a018c6ee'
            },
            label: 'Contact Us',
            url: 'http://www.nva.com/contact-us'
          }]
        }
      }]
    }
  }],
  appointmentCta: {
    label: 'Book Appointment',
    url: 'http://www.nva.com/contact-us',
    dataAnalyticsValue: 'appointment'
  }
};
var mockDataNavItem = {
  key: '123',
  keyCategory: {
    sys: {
      id: 'eed6be15-7f82-5a01-84c9-50ee0977c0e5'
    },
    keyCategoryName: 'Resources',
    name: 'Resources Category ',
    groupCollection: {
      items: [{
        sys: {
          id: '47a33d50-ad21-5d6b-8b93-e5fa08a13be0'
        },
        name: 'Resources Group Container 1',
        groupItemCollection: {
          items: [{
            sys: {
              id: '4e988760-2a88-5599-9c07-0fbfcb50ed63'
            },
            label: 'Terms & Conditions',
            url: 'http://www.nva.com/privacy-policy'
          }, {
            sys: {
              id: '9151eba6-a99f-5643-bc0e-b8fe86e7daf5'
            },
            label: 'Privacy Policy',
            url: null
          }, {
            sys: {
              id: 'a0270494-502f-51a5-abd7-bef8a018c6ee'
            },
            label: 'Contact Us',
            url: 'http://www.nva.com/contact-us'
          }]
        }
      }]
    }
  },
  variation: 'Variation-A'
};
var mockDataNavItemLink = {
  variation: 'Variation-A',
  keyCategory: [{
    sys: {
      id: '4e2b1fc3-bdb1-509c-8ee0-cba3cbdf0092'
    },
    label: 'About Us',
    url: 'http://www.nva.com/about-us',
    dataAnalyticsValue: 'aboubt-us'
  }]
};
export { mockData, mockDataNavItem, mockDataNavItemLink };